const saveMarkForExport = (matchId, value, setData, saveResults) => {
    setData((prev) => {
      if (!prev) return prev;
  
      const newResults = prev.results.map((result) => {
        const updatedMatches = result.Matches.map((matchObj) => {
          const key = Object.keys(matchObj)[0];
          const match = matchObj[key];
  
          if (result.id !== matchId) return matchObj;
  
          return {
            [key]: {
              ...match,
              "Mark For Export": value,
            },
          };
        });
  
        return { ...result, Matches: updatedMatches };
      });
  
      saveResults(prev.resultsID, newResults);
      return { ...prev, results: newResults };
    });
  };
  
  export default saveMarkForExport;
  